/* Bea Joyas — filtrado de colección con AJAX + bottom-sheet mobile.
   Progresivo: si JS falla, el <form method="get"> sigue funcionando por recarga.
   Reemplaza grilla, formulario de filtros, chips y contadores sin recargar la página. */
(function () {
  if (!document.getElementById('CollMain')) return;
  var t;

  function byId(id) { return document.getElementById(id); }

  function setBusy(b) {
    var m = byId('CollMain');
    if (m) { m.style.opacity = b ? '.45' : ''; m.style.pointerEvents = b ? 'none' : ''; }
  }

  function swap(id, doc) {
    var n = doc.getElementById(id), o = byId(id);
    if (n && o) o.innerHTML = n.innerHTML;
  }

  function formURL(f) {
    var params = new URLSearchParams();
    new FormData(f).forEach(function (val, key) {
      var v = String(val).trim();
      if (v !== '') params.append(key, v);
    });
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  function go(url, push) {
    setBusy(true);
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap('CollMain', doc);
        swap('FacetFilterForm', doc);
        swap('CollChips', doc);
        swap('CollSortForm', doc);
        var nc = doc.querySelectorAll('[data-coll-count]');
        document.querySelectorAll('[data-coll-count]').forEach(function (el, i) {
          if (nc[i]) el.textContent = nc[i].textContent;
        });
        var nb = doc.querySelector('[data-facets-bubble]');
        var ob = document.querySelector('[data-facets-bubble]');
        if (ob) {
          if (nb) { ob.textContent = nb.textContent; ob.hidden = nb.hasAttribute('hidden'); }
          else ob.hidden = true;
        }
        if (push !== false) history.pushState({}, '', url);
        setBusy(false);
      })
      .catch(function () { location.href = url; });
  }

  function setSheet(open) {
    var a = byId('CollFilters');
    if (!a) return;
    a.classList.toggle('is-open', open);
    if (open) { (window.BEA_lockScroll || function () { document.body.style.overflow = 'hidden'; })(); }
    else { (window.BEA_unlockScroll || function () { document.body.style.overflow = ''; })(); }
  }

  document.addEventListener('change', function (e) {
    var f = e.target.closest ? e.target.closest('#FacetFilterForm') : null;
    if (f) {
      clearTimeout(t);
      var delay = e.target.type === 'number' ? 350 : 60;
      t = setTimeout(function () { go(formURL(f), true); }, delay);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id === 'CollSortForm') {
      // orden: mergeamos sort_by sobre la URL actual (que ya tiene los filtros activos),
      // en vez de serializar el form (sus hidden inputs podrían estar viejos tras filtrar por AJAX).
      e.preventDefault();
      var sel = form.querySelector('[name="sort_by"]');
      var params = new URLSearchParams(location.search);
      if (sel) params.set('sort_by', sel.value);
      var qs = params.toString();
      go(location.pathname + (qs ? '?' + qs : ''), true);
      return;
    }
    if (form.id === 'FacetFilterForm') { e.preventDefault(); go(formURL(form), true); }
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-facet-link]') : null;
    if (link) { e.preventDefault(); go(link.getAttribute('href'), true); return; }
    if (e.target.closest && e.target.closest('[data-facets-open]')) { setSheet(true); return; }
    if (e.target.closest && e.target.closest('[data-facets-close]')) { setSheet(false); return; }
  });

  window.addEventListener('popstate', function () {
    go(location.pathname + location.search, false);
  });
})();
